export default "__VITE_ASSET__k78n04Rn__"